import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  content: {
    margin: '70px auto',

    '@media screen and (max-width: 1023px)': {
      maxWidth: 'calc(100% - 40px)',
    },

    '&::after, &::before': {
      clear: 'both',
      content: '""',
      display: 'block',
    },

    '.alignnone': {
      margin: '5px 20px 20px 0',
    },

    '.aligncenter, div.aligncenter': {
      display: 'block',
      margin: '5px auto 5px auto',
    },

    '.alignright': {
      float: 'right',
      margin: '5px 0 20px 20px',
    },

    '.alignleft': {
      float: 'left',
      margin: '5px 20px 20px 0',
    },

    'a img.alignright': {
      float: 'right',
      margin: '5px 0 20px 20px',
    },

    'a img.alignnone': {
      margin: '5px 20px 20px 0',
    },

    'a img.alignleft': {
      float: 'left',
      margin: '5px 20px 20px 0',
    },

    'a img.aligncenter': {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },

    '.wp-caption': {
      background: '#fff',
      border: '1px solid #f0f0f0',
      maxWidth: '96%',
      padding: '5px 3px 10px',
      textAlign: 'center',
    },

    '.wp-caption.alignnone': {
      margin: '5px 20px 20px 0',
    },

    '.wp-caption.alignleft': {
      margin: '5px 20px 20px 0',
    },

    '.wp-caption.alignright': {
      margin: '5px 0 20px 20px',
    },

    '.wp-caption img':  {
      border: '0 none',
      height: 'auto',
      margin: 0,
      maxWidth: '98.5%',
      padding: 0,
      width: 'auto',
    },

    '.wp-caption p.wp-caption-text': {
      fontSize: '11px',
      lineHeight: '17px',
      margin: 0,
      padding: '0 4px 5px',
    },

    '.screen-reader-text': {
      border: '0',
      clip: 'rect(1px, 1px, 1px, 1px)',
      clipPath: 'inset(50%)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: '0',
      position: 'absolute !important',
      width: '1px',
      wordWrap: 'normal !important',
    },

    '.screen-reader-text:focus': {
      backgroundColor: '#eee',
      clip: 'auto !important',
      clipPath: 'none',
      color: '#444',
      display: 'block',
      fontSize: '1em',
      height: 'auto',
      left: '5px',
      lineHeight: 'normal',
      padding: '15px 23px 14px',
      textDecoration: 'none',
      top: '5px',
      width: 'auto',
      zIndex: '100000',
    },
  },
  formBg: {
    background: 'linear-gradient(76.62deg,#8086F2 -4.79%,#32CDEA 100%)',
    borderRadius: '12px',
    boxShadow: '0px 5px 15px rgb(0 0 0 / 25%)',
    display: 'block',
    margin: '0 auto',
    maxWidth: 'calc(100% - 40px)',
    padding: '3px',
    width: '730px',

    '& > div': {
      backgroundColor: '#fff',
      borderRadius: '10px',
      paddingBottom: ['30px', '60px'],
      paddingTop: ['35px', '70px'],
    },
  },
  main: {
    'input:not([type="submit"]):not([type="button"]):not([type="checkbox"]), select, textarea': {
      background: '#fff',
      border: '2px solid #bfbfbf',
      color: '#7f7f7f',
      display: 'block',
      fontSize: '21px',
      margin: '0 auto',
      marginBottom: '15px',
      padding: '13px 14px 11px',
      width: '100%',

      '&::placeholder': {
        color: '#A0A4A8',
        textTransform: 'uppercase',
      },
    },

    '.single-checkbox-row': {
      position: 'relative',
    },

    'input[type="checkbox"]': {
      display: 'none',
    },

    'input[type="checkbox"] + label': {
      cursor: 'pointer',
      display: 'block',
      marginBottom: '15px',
      transition: 'all 0.3s',

      '&:hover': {
        color: '#35cceb',
      },
    },

    'input[type="checkbox"]:checked + label::after': {
      backgroundColor: '#bfbfbf',
      content: '""',
      display: 'block',
      height: '20px',
      left: '4px',
      position: 'absolute',
      top: '4px',
      width: '20px',
    },

    'input[type="checkbox"] + label::before': {
      background: '#fff',
      border: '2px solid #bfbfbf',
      content: '""',
      float: 'left',
      marginRight: '15px',
      height: '24px',
      width: '24px',
    },

    'form > *': {
      margin: '0 auto',
      maxWidth: 'calc(100% - 40px)',
      position: 'relative',
      width: '434px !important',
    },

    'input[type="submit"], input[type="button"], button': {
      alignItems: 'center',
      backgroundImage: 'linear-gradient(270deg, #35cceb 0, #8781f4)',
      border: 'none',
      borderRadius: '24px',
      boxShadow: '-1px 4px 15.68px 0.32px rgb(0 0 0 / 14%)',
      color: '#fff',
      cursor: 'pointer',
      display: 'block',
      fontSize: '20px',
      fontWeight: 600,
      margin: '0 auto',
      minHeight: '50px',
      minWidth: '233px',
      mt: '50px',
      padding: '10px 20px',
      transition: 'all .3s ease-in',

      '&:hover': {
        backgroundColor: 'var(--theme-ui-colors-sungoldDarken-100,#E2A903)',
        transform: 'scale(1.1)',
      },
    },
  },
  twoColumns: {
    '@media screen and (min-width: 1023px)': {
      '.section-content': {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridColumnGap: '30px',
      },

      '.section-content > div': {
        maxWidth: '100%',
      },

      '.form-column > div': {
        position: 'sticky',
        top: '242px',
      },

      '.content-column > div': {
        mt: '43px',
      },
    },
    '@media screen and (max-width: 1022px)': {
      '.content-column': {
        maxWidth: 'calc(100% - 40px)',
      },
    },
  },
  postHtmlContent: {
    display: 'block',
    m: '20px auto 0',
    width: 'calc(100% - 40px)',
  },
};
